// excelToIBusinessMapperのラッパーメソッドの集まり

import { TranslateInputFileManager } from '@/appLogic/fileManager/translate/translateInputFileManager';
import { IYearMonth } from '@/coreDomainsModule/date';
import { ExcelYearMonth, TranslateExcelBusiness } from '@/coreDomainsModule/translateExcel';
import { ExcelTranslateError } from '@/coreDomainsModule/translateExcel';
/**
 * 処理の進捗状況を更新する関数の型定義
 */
type ProgressUpdateFunction = (progressTaskName: string, addValue: number) => void;

/**
 * 解凍したzipファイルの中にある内示エクセルを読む
 * @param unZippedFiles 解凍済みファイルオブジェクト
 * @param inputFormObject IBusinessをラップしたエクセル転記情報
 * @param outputErrors エラーを溜めておくオブジェクト
 * @param receiveYearMonth 内示受領年月
 * @param translateInputFileManager 入力ファイルマネージャ
 * @param updateProgressFunc 処理の進捗状況を更新する関数
 */
export const bulkReadAnnounceExcel = async (
  unZippedFiles: File[],
  inputFormObject: Record<string, TranslateExcelBusiness>,
  outputErrors: ExcelTranslateError[],
  receiveYearMonth: Record<string, IYearMonth>,
  translateInputFileManager: TranslateInputFileManager,
  updateProgressFunc: ProgressUpdateFunction
) => {
  for (const unZippedFile of unZippedFiles) {
    // .xlsx以外のファイルは読まない(.DS_Storeとか読むと困るので)
    if (!unZippedFile.name.includes('.xlsx')) continue;
    // このエクセルファイルの受領月情報を初期化する
    receiveYearMonth[unZippedFile.name] = { year: 9999, month: 12 };
    await updateProgressFunc(unZippedFile.name + ' 読み込み中・・・', 0);
    await translateInputFileManager.readAnnounceExcel(
      unZippedFile,
      inputFormObject,
      outputErrors,
      unZippedFile.name,
      receiveYearMonth[unZippedFile.name],
      ...[translateInputFileManager.ANNOUNCE_MAPPER]
    );
  }
};

/**
 * 解凍したzipファイルの中にある日別内示エクセルを読む
 * @param unZippedFiles 解凍済みファイルオブジェクト
 * @param inputFormObject IBusinessをラップしたエクセル転記情報
 * @param outputErrors エラーを溜めておくオブジェクト
 * @param receiveYearMonth 内示受領年月
 * @param translateInputFileManager 入力ファイルマネージャ
 * @param updateProgressFunc 処理の進捗状況を更新する関数
 */
export const bulkReadDailyAnnounceExcel = async (
  unZippedFiles: File[],
  inputFormObject: Record<string, TranslateExcelBusiness>,
  outputErrors: ExcelTranslateError[],
  receiveYearMonth: Record<string, IYearMonth>,
  translateInputFileManager: TranslateInputFileManager,
  updateProgressFunc: ProgressUpdateFunction
) => {
  let hasClearedMonthlyAnnounce = false;
  const clearMonthlyAnnounceOnce = () => {
    if (hasClearedMonthlyAnnounce) return;
    Object.values(inputFormObject).forEach((formObj) => {
      formObj.customerAnnounce = [];
    });
    hasClearedMonthlyAnnounce = true;
  };

  for (const unZippedFile of unZippedFiles) {
    // .xlsx以外のファイルは読まない(.DS_Storeとか読むと困るので)
    if (!unZippedFile.name.includes('.xlsx')) continue;
    receiveYearMonth[unZippedFile.name] = { year: 9999, month: 12 };
    await updateProgressFunc(unZippedFile.name + ' 読み込み中・・・', 0);
    await translateInputFileManager.readDailyAnnounceExcel(
      unZippedFile,
      inputFormObject,
      outputErrors,
      unZippedFile.name,
      receiveYearMonth[unZippedFile.name],
      clearMonthlyAnnounceOnce,
      ...[translateInputFileManager.ANNOUNCE_DAILY_MAPPER]
    );
  }
};
